import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const useTranslatedDateFormat = (dateFormatObj) => {
  const trans = useSelector(translator);

  if (!dateFormatObj) return { ...dateFormatObj };

  // Translate relative day labels
  let translatedDay = '';
  if (dateFormatObj.day === 'Today, ') {
    translatedDay = trans('TODAY') + ', ';
  } else if (dateFormatObj.day === 'Tomorrow, ') {
    translatedDay = trans('TOMORROW') + ', ';
  } else if (dateFormatObj.day === 'Yesterday, ') {
    translatedDay = trans('YESTERDAY') + ', ';
  }

  // Extract parts from dateFormat
  const parts = dateFormatObj.dateFormat.split(' ');
  const dayName = parts[0]; // e.g., "Monday"
  const monthName = parts[1]; // e.g., "July"
  const dateNum = parts[2]; // e.g., "14"
  const year = parts[3] || ''; // optional

  // Translate day and month names using uppercase keys
  const translatedDayName = trans(dayName.toUpperCase()) || dayName;
  const translatedMonth = trans(monthName.toUpperCase()) || monthName;

  const translatedDateFormat = `${translatedDayName} ${translatedMonth} ${dateNum} ${year}`.trim();
  const translatedDayDateFormat = translatedDay + translatedDateFormat;

  return {
    ...dateFormatObj,
    day: translatedDay,
    dateFormat: translatedDateFormat,
    dayDateformat: translatedDayDateFormat,
  };
};

export default useTranslatedDateFormat;
